import { jsx as a } from "react/jsx-runtime";
import * as r from "@radix-ui/react-switch";
import { c as d } from "./cn-B6yFEsav.js";
function o({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    r.Root,
    {
      "data-slot": "switch",
      className: d(
        // `flex`, not the CLI's `inline-flex`: an inline-level control sits on the text baseline and the
        // line box reserves descender space under it, making the label row taller than the legacy one,
        // whose `SwitchSvg` was an `svg.block`. `flex` keeps `items-center` for the thumb.
        "peer flex h-3 w-5 shrink-0 items-center rounded-full border px-[1.5px] outline-hidden",
        "border-(--palette-N600) bg-(--palette-N600)",
        "data-[state=checked]:border-(--palette-P500) data-[state=checked]:bg-(--palette-P500)",
        // Disabled overrides the on/off colours, as the SVG did — hence the doubled-up
        // `disabled:data-[state=checked]:` pair. Without it the two variants tie on specificity
        // and which one paints is decided by the order Tailwind happens to emit them in.
        "disabled:border-(--palette-N300) disabled:bg-(--palette-N0)",
        "disabled:data-[state=checked]:border-(--palette-N300) disabled:data-[state=checked]:bg-(--palette-N0)",
        "disabled:cursor-auto",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(
        r.Thumb,
        {
          "data-slot": "switch-thumb",
          className: d(
            "pointer-events-none block size-[7px] rounded-full ring-0 transition-transform",
            "bg-(--palette-N0) data-[disabled]:bg-(--palette-N300)",
            "data-[state=unchecked]:translate-x-0 data-[state=checked]:translate-x-[8px]"
          )
        }
      )
    }
  );
}
function i({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      className: d("animate-pulse rounded-md bg-muted", e),
      style: { backgroundColor: "#f0f0f0" },
      ...t
    }
  );
}
export {
  o as S,
  i as a
};
//# sourceMappingURL=skeleton-BsC3YUir.js.map
